import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=73ac0bef&scoped=true"
import script from "./UserHistory.vue?vue&type=script&lang=ts"
export * from "./UserHistory.vue?vue&type=script&lang=ts"
import style0 from "./UserHistory.vue?vue&type=style&index=0&id=73ac0bef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ac0bef",
  null
  
)

export default component.exports